import { useState } from 'react';
import cn from 'classnames';

const CheckInput = ({ text, onChange, value, validation, name }) => {
  return (
    <label htmlFor={name} className="relative flex items-center">
      <input
        type="checkbox"
        name={name}
        id={name}
        className="absolute inset-0 mr-10 opacity-0 cursor-pointer"
        checked={!!value}
        onChange={onChange}
      />
      <div
        className={cn(
          'relative w-16 h-16 rounded-full border border-solid border-cyan flex-shrink-0 mr-10 cursor-pointer p-2',
          { 'border-red': validation && !value }
        )}
      >
        <div
          className={cn(
            'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full duration-40',
            {
              'bg-cyan-dark': value
            }
          )}
        ></div>
      </div>
      <span className="text-12 sm:text-14 text-cyan-dark font-light">{text}</span>
    </label>
  );
};
export default CheckInput;
